// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable init-declarations */
import {
  differenceInDays,
  subDays,
  addDays,
  addMonths,
  isWithinInterval,
  isAfter,
  isSameDay,
  startOfDay,
  endOfDay,
  format,
} from "date-fns"
import { legacyParse } from "@radek-palisa/date-fns-upgrade/lib/v2"
import { equals, compose, uniq } from "ramda"

import { get } from "../../utils/get"
import set from "../../utils/set"
import { DATE_FNS_FORMAT } from "../../consts/date"
import constants from "../../consts/config"
import { DATE_TYPES } from "./SearchDate"
import type { SearchDate, DateRange, TimeToStay, Anytime, NoReturn } from "./SearchDate"

export const getId = (date: SearchDate): string => {
  switch (date.type) {
    case DATE_TYPES.DATE_RANGE:
      return uniq([
        format(legacyParse(date.from), DATE_FNS_FORMAT),
        format(legacyParse(date.to), DATE_FNS_FORMAT),
      ]).join("_")
    case DATE_TYPES.TIME_TO_STAY:
      return uniq([date.min, date.max]).join("-")
    default:
      return date.type
  }
}

export const isDateRange = (date: SearchDate): boolean => date.type === DATE_TYPES.DATE_RANGE

export const isSingleDate = (date: SearchDate): boolean =>
  // @ts-expect-error: Flow to TS migration.
  isDateRange(date) && isSameDay(date.from, date.to)

export const isTimeToStay = (date: SearchDate): boolean => date.type === DATE_TYPES.TIME_TO_STAY

export const isAnytime = (date: SearchDate): boolean => date.type === DATE_TYPES.ANYTIME

export const isNoReturn: (arg1: SearchDate) => boolean = compose(
  equals(DATE_TYPES.NO_RETURN),
  get("type"),
)

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const createRangeAround = (date: Date, dayCount: number = 1): DateRange => {
  const subtract = differenceInDays(date, new Date()) < dayCount ? 0 : dayCount
  return {
    type: DATE_TYPES.DATE_RANGE,
    isDefault: false,
    from: subDays(date, subtract),
    to: addDays(date, dayCount),
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const createDateRange = (from: Date, to: Date, isDefault: boolean = false): DateRange => ({
  type: DATE_TYPES.DATE_RANGE,
  isDefault,
  from,
  to,
})

export const createTimeToStay = (
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  min: number = 2,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  max: number = 10,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  isDefault: boolean = false,
): TimeToStay => ({
  type: DATE_TYPES.TIME_TO_STAY,
  isDefault,
  min,
  max,
})

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const createNoReturn = (isDefault: boolean = false): NoReturn => ({
  type: DATE_TYPES.NO_RETURN,
  isDefault,
})

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const createAnytime = (isDefault: boolean = false): Anytime => ({
  type: DATE_TYPES.ANYTIME,
  isDefault,
})

const DEFAULT_DATE_RANGE_DATES = 3

export const toDateRange = (from: Date) => ({
  type: DATE_TYPES.DATE_RANGE,
  isDefault: false,
  from,
  to: addDays(from, DEFAULT_DATE_RANGE_DATES),
})

export const nextDate = (lastDate?: Date | SearchDate): DateRange => {
  let from
  if (lastDate instanceof Date) {
    from = lastDate
  } else if (lastDate && lastDate.type === DATE_TYPES.DATE_RANGE) {
    from = lastDate.to
  } else {
    from = new Date()
  }

  return toDateRange(addDays(from, DEFAULT_DATE_RANGE_DATES))
}

export const getAnytimeRange = (): DateRange => ({
  type: DATE_TYPES.DATE_RANGE,
  isDefault: false,
  from: addDays(new Date(), 1),
  to: addMonths(new Date(), Number(constants.maxSearchMonths)),
})

export const setIsDefault = (value: boolean, date: SearchDate): SearchDate =>
  set("isDefault", value, date)

export const includesDate = (searchDate: SearchDate, date: Date): boolean =>
  searchDate.type === DATE_TYPES.DATE_RANGE &&
  isWithinInterval(date, { start: startOfDay(searchDate.from), end: endOfDay(searchDate.to) })

// is first after or equal second?
export const isAfterOrEqual = (first: Date, second: Date): boolean =>
  isAfter(first, second) || isSameDay(first, second)
